import React, { memo } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

const FeaturedSection = memo(({ theme, sectionId }) => {
  const FeaturedLayout = dynamic(() => import(/* webpackChunkName: 'FeaturedSectionLayout' */ `../../../../../containers/home-page/views/sections/featured/layouts/${theme.layout}`))

  return (
    <FeaturedLayout sectionId={sectionId} />
  )
}, (prevProps, nextProps) => {
  return (prevProps.theme && prevProps.theme.layout) === (nextProps.theme && nextProps.theme.layout)
})

FeaturedSection.propTypes = {
  theme: PropTypes.object,
  sectionId: PropTypes.number
}

export default FeaturedSection
